<template>
  <div class="controls">
    <v-btn class="learn large" v-if="showLearn" @click="learn">learn more</v-btn>
    <v-btn class="start large" color="primary" @click="start">let's start</v-btn>
  </div>
</template>

<script>
export default {
  props: {
    showLearn: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    learn() {
      this.$emit("learn");
    },
    start() {
      let path = 'start';
      if(this.$route.path.includes('incl-markt-comm')){
        path = 'start-incl-markt-comm';
      }
      else if (this.$route.path.includes('reseller-no-comm')) {
        path = 'start-reseller-no-comm'
      }
      else if(this.$route.path.includes('reseller')){
        path = 'start-reseller';
      }
      this.$router.push(path);
    }
  }
};
</script>

<style scoped>
#app.mobile .learn {
  display: none;
}
.controls > *:not(:last-child) {
  margin-right: 50px;
}
</style>
